import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "../providers/AnalyticsProvider";

export const AnalyticsPageTracker: React.FC = () => {
  const location = useLocation();
  const { page } = useAnalytics();

  useEffect(() => {
    // Track page view when route changes
    page({
      page_path: location.pathname,
      page_search: location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search, page]);

  return null; // This component doesn't render anything
};
